import { apiCallBack } from '../ApiMethods';
import {
  CreateModelAuditReportTaskResponse,
  CreateModelAuditReportTaskResult,
  ModelAuditReportPayload,
  ModelAuditReportTask,
} from './types';

export const createModelAuditReportTask = (
  data: ModelAuditReportPayload
): Promise<CreateModelAuditReportTaskResult> =>
  apiCallBack<
    undefined,
    ModelAuditReportPayload,
    CreateModelAuditReportTaskResponse
  >({
    method: 'POST',
    url: '/api/v2/classif-ai/daily-operations/automation/model-audit-report/task/',
    data: {
      file_set_filters: data.file_set_filters,
      timezone: data.timezone,
      subscription_id: data.subscription_id,
    },
  }).then(r => ({ ...r.data, status: r.status }));

// Re-read on every download: the task `url` is a presigned S3 link that
// expires, so a cached task list entry may hold a dead url.
export const getModelAuditReportTask = (
  taskId: string
): Promise<ModelAuditReportTask | undefined> =>
  apiCallBack<undefined, undefined, ModelAuditReportTask>({
    method: 'GET',
    url: `/api/v1/classif-ai/tasks/${taskId}/`,
  }).then(r => r.data);
